import React from 'react'
import {Switch, Redirect, Route, withRouter} from 'react-router-dom'
import {Fill, Slot} from 'react-slot-fill'
import {ThemeProvider, css} from 'styled-components'
import {closePopups, postFetcher, StartlibsProvider, getFetcher} from 'startlibs'
import {ice} from 'icepath'
import {connect} from 'react-redux'
import {getColor} from 'startlibs/lib/lib'
import {Button, Loading, Dialog, Icon} from 'startlibs/lib/components'
import {Dashboard} from './dashboard/Dashboard'
import {Navbar} from './Navbar'
import {PasswordRecovery} from './signin/PasswordRecovery'
import {ProfileData} from './user/ProfileData'
import {SignIn} from './signin/SignIn'
import {SignUp} from './signin/SignUp'
import {Workstations} from './workstations/Workstations'
import {Report} from './report/Report'
import {Terms} from './public/Terms'
import {RedefinePassword} from './signin/RedefinePassword'
import {clearNotifications, getAccount, setNotifications} from './reducers'
import {withToggles} from 'startlibs/lib/hocs'
import {AccountSettings} from './user/AccountSettings'
import {PageLoader, ErrorBoundary} from 'startlibs/lib/components'
import styled from 'styled-components'
import {Errors, IconRadioBox} from 'startlibs/lib/form'
import {PageError} from './PageError'
// import {Checkout} from './checkout/Checkout'
import {Billing, getCancelDate, FormattedDate} from './user/Billing'
import {lighten} from 'polished'
import {daysLeft, downloadReportsArchive, INACTIVE_ACCOUNT_STATUSES, normalizeSubscription} from './lib'
import {ExpiredShare} from './public/ExpiredShare'
import {PageNotFound} from './public/PageNotFound'
import {ConfirmDeleteAccount} from './user/ConfirmDeleteAccount'
import {DeleteAccountFinished} from './public/DeleteAccountFinished'
import {ExpiredDeletionLink} from './public/ExpiredDeletionLink'
import {DownloadStudyPage} from './shareModule/DownloadStudyPage'
import {StorageCheckout} from './checkout/StorageCheckout'
import {CreditCardUpdate} from './user/CreditCardUpdate'
import {ReportCheckout} from './checkout/ReportCheckout'
import {FirstSteps} from './public/FirstSteps'

export const LoadingUser = styled(({className}) => <div className={className}>
  <img alt="" src="/public/favicon.png"/>
  <Loading size={40} borderWidth={6}/>
</div>)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  * {
    margin-left: auto;
    margin-right: auto;
  }
  img {
    max-width: 11rem;
    margin-bottom: 4rem;
  }
`

const PurviewPageLoader = styled(PageLoader)`
  background: #00D2FF;
`

const BottomBannerPlaceholder = styled.div`
  height: ${props => props.size}px;
`

const BottomBanner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 101;
  background: ${props => (props.warning ? '#eedcaa' : props.canceled ? (lighten(0.425, getColor('alert')(props))) : (lighten(0.5, getColor('main')(props))))};
  .banner-content-container {
    max-width: 62rem;
    margin: 0 auto;
    display: flex;
    padding: 2rem;
    font-size: 13px;
    align-items: center;
    justify-content: center;
    color: ${props => (props.warning ? 'rgba(0,0,0,0.6)' : props.canceled ? (getColor('alert')) : (getColor('main')))};
  }
  .banner-content {
    margin-right: 1rem;
  }
  .additional-info {
    font-size: 12px;
  }
  ${Button}{
    flex-shrink: 0;
    font-weight: 600;
  }
  .close-icon {
    position: absolute;
    width: 32px;
    height: 32px;
    font-size: 24px;
    line-height: 32px;
    cursor: pointer;
    border-radius: 50%;
    text-align: center;
    background: ${props => (props.warning || props.canceled ? 'rgba(0,0,0,0.1)' : (lighten(0.425, getColor('main')(props))))};
    color: ${props => (props.warning || props.canceled ? 'rgba(0,0,0,0.4)' : (getColor('main')))};
    z-index: 1000;
    bottom: 50%;
    transform: translateY(50%);
    right: 1rem;
    :hover {
      background: ${props => (props.warning || props.canceled ? 'rgba(0,0,0,0.15)' : (lighten(0.39, getColor('main')(props))))};
    }
  }
  @media (max-width: 820px) {
    .banner-content-container {
      margin: 0 2.75rem 0 0;
    }
  }
  @media (max-width: 550px) {
    .banner-content-container {
      padding: 1.5rem;
      font-size: 12px;
      display: block;
      margin-right: 0;
    }
    .banner-content {
      margin-bottom: 1rem;
    }
    .close-icon {
      bottom: 1.5rem;
      transform: none;
    }
  }
`

class AppPresentation extends React.Component {

  constructor(props) {
    super(props)
    this.originalLocation = props.location.pathname
  }

  static startlibsConfig = {
    confirmDialogLabels: {
      title: 'Your changes will not be saved',
      content: 'The changes made in this screen were not saved. Would you like to quit anyway?',
      confirm: 'Save Changes',
      discard: 'Discard Changes',
      cancel: 'Cancel'
    },
    FormUploadingImageError: 'The image is being uploaded, please wait a monent.',
    ErrorDialog: {
      title: 'This content could not be loaded',
      content: <React.Fragment>Please refresh the page and try again. <br/>If the problem persists, contact
        us.</React.Fragment>,
      close: 'Close'
    },
    fetchRoutes: [
      ['/', '/api/reports?size=40&page=0&sort=last_Saved,desc'],
      [/\/profile(\?.+)?/, '/api/profiles/'],
      ['/workstations', '/api/station-tokens'],
      ['/billing', '/api/stripe-customer'],
      [/(\/storage)?\/checkout\/?(\?.*of=plan.*)/, '/api/stripe-customer'],
      [/(\/storage)?\/checkout\/?(\?.+)?/, '/api/stripe-plans?'],
      [/\/report\/([^/]+)$/, '/api/report-json/$1'],
      [/\/reportCleanup\/.+/, '/api/stripe-customer'],
      [/\/deleteAccount\/.+/, '/api/stripe-customer']
    ]
  }

  handleWindowScroll = () => {
    const classes = document.body.className.split(' ')
    if (!window.pageYOffset !== (classes.indexOf('scrolled') < 0)) {
      const className = classes.filter(_ => _ !== 'scrolled').join(' ')
      document.body.className = className + (window.pageYOffset ? ' scrolled' : '')
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleWindowScroll)
    const log = () => this.props.getAccount().then(({errors}) => {
        if (errors && !(errors instanceof Error))
          localStorage.removeItem('hasLogged')
        this.props.hasFetchedUser.open()
      }
    )
    if (localStorage.getItem('hasLogged') === 'true') {
      log()
    } else {
      getFetcher('/api/authenticate/').then(({errors}) => {
          if (errors) {
            this.props.hasFetchedUser.open()
          } else {
            log()
          }
        }
      ).catch(this.props.hasFetchedUser.open)
    }

  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleWindowScroll)
  }

  componentDidUpdate(oldProps) {
    // const completedProfile = (oldProps.user && this.props.user && oldProps.user.hasProfile === false && this.props.user.hasProfile === true)
    // if (this.props.user.id && !this.props.originalLocation.isOpen) {
    //   this.props.originalLocation.open()
    // }
  }

  static theme = {
    startlibs: {
      Button: css`
          box-shadow: inset 0 -3px 0 0 rgba(0,0,0,0.15);
          border-radius: 5px;
          ${props => props.small && css`
            box-shadow: inset 0 -2px 0 0 rgba(0,0,0,0.15);
            ${Loading} {
              width: 18px;
              height: 18px;
              border-width: 3px;
            }
          `}
      `,
      ContextMenu: `
        box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);
        border-radius: 5px;
      `,
      Popup: `
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);
        border-radius: 4px;
      `,
      ListItem: css`
        ${props => props.hover && css`
          & > a, & > label {
            background-color: ${getColor('main')};
            color: white;
          }
        `}
        ${props => props.highlight && css`
            color: ${getColor('main')};
            font-weight: 600;
        `}
      `,
      Dialog: css`
        background-color: white;
        border-radius: 6px;
        ${Dialog.Content} {
          border-top: none;
        }
        ${Dialog.Footer} {
          border-top: none;
        }
        ${Dialog.DialogIcon} {
          font-size: 100px;
        }
      `,
      FieldLabel: `
        font-weight: 600;
      `,
      TextInput: `
        border-radius: 5px;
      `,
      IconRadioBox: css`
        border-radius: 5px;
        ${Icon} {
          font-size: 120px;
          line-height: 56px;
        }
        ${IconRadioBox.Text} {
          padding: 1rem;
          box-shadow: inset 0 -3px 0 0 rgba(0,0,0,.15);
        }
      `,
      ErrorItem: css`
        background: ${getColor('alert')};
        color: white;
        border: 0;
        ${Errors.CloseIcon} {
          color: white;
          background-color: rgba(0, 0, 0, 0.2);
          width: 20px;
          height: 20px;
          line-height: 20px;
          &:hover {
            background: rgba(0,0,0,0.25);
          }
        }
        a {
          color: white;
          font-weight: 600;
        }
      `
    },
    colors: {
      gray30: '#1e1e1e',
      gray60: '#3c3c3c',
      gray90: '#5a5a5a',
      gray120: '#787878',
      gray150: '#969696',
      gray180: '#b4b4b4',
      gray210: '#d2d2d2',
      gray240: '#f0f0f0',
      main: '#008bd2',
      secondary: '#28AAE1',
      alert: '#C3282D',
      warning: '#e6932e',
      success: '#39B54A',
      physician: '#00a99d',
      organization: '#ed1e79'
    },
    iconFont: 'pix-icons',
    icons: {
      'note': '\ue935',
      'delete': '\ue934',
      'help': '\ue933',
      'download': '\ue930',
      'print': '\ue931',
      'email': '\ue932',
      'arrow-up-line': '\ue92c',
      'arrow-down-line': '\ue92d',
      'arrow-left-line': '\ue92e',
      'arrow-right-line': '\ue92f',
      'hlogo-right': '\ue929',
      'hlogo-left': '\ue92a',
      'hlogo-center': '\ue92b',
      'reload': '\ue927',
      'image': '\ue928',
      'external-link-line': '\ue923',
      'edit': '\ue924',
      'reorder': '\ue925',
      'move': '\ue926',
      'bold': '\ue91b',
      'italic': '\ue91c',
      'underline': '\ue91d',
      'strikethrough': '\ue91e',
      'insertUnorderedList': '\ue91f',
      'insertOrderedList': '\ue920',
      'outdent': '\ue921',
      'indent': '\ue922',
      'sort': '\ue91a',
      'zip-file': '\ue919',
      'calendar': '\ue917',
      'lock': '\ue918',
      'directories': '\ue913',
      'files': '\ue914',
      'failure': '\ue915',
      'external-link': '\ue916',
      'plus': '\ue910',
      'edit-box': '\ue911',
      'sign-out': '\ue912',
      'share': '\ue90a',
      'arrow-down': '\ue903',
      'arrow-up': '\ue904',
      'arrow-left': '\ue905',
      'arrow-right': '\ue906',
      'upload': '\ue907',
      'view': '\ue908',
      'settings': '\ue909',
      'search': '\ue90b',
      'check': '\ue90c',
      'x': '\ue90d',
      'plus-circle': '\ue90e',
      'notification': '\ue90f',
      'user': '\ue900',
      'physician': '\ue901',
      'organization': '\ue902',
      'report': '\ue936',
      'checked-report': '\ue937',
      'station': '\ue938',
      'warning': '\ue939',
      'premium': '\ue93a',
      'credit-card': '\ue93b',
      'clock': '\ue93d',
      'zoom-in': '\ue93e',
      'zoom-out': '\ue93f',
      'minus': '\ue941',
      'plus': '\ue910',
      'home-line': '\ue940',
      'home': '\ue942',
    }
  }

  closePopups = () => {
    if (this.props.openPopup) {
      this.props.closePopups()
    }
  }

  render() {
    const {user, hasFetchedUser} = this.props
    const canCheckout = user.accountStatus === 'active' || user.accountStatus === 'past_due'
    const publicRoutes = [
      <Route key="storageCheckout" path="/storage/checkout" exact render={(props) => canCheckout ? <StorageCheckout {...props}/> : <Redirect to="/"/>}/>,
      <Route key="reportCheckout" path="/checkout" exact render={(props) => canCheckout ? <ReportCheckout {...props}/> : <Redirect to="/"/>}/>,
      <Route key="license" path="/license" exact component={Terms}/>,
      <Route key="expired" path="/error/linkexpired" exact component={ExpiredShare}/>,
      <Route key="expiredDelete" path="/error/deletionExpired" exact component={ExpiredDeletionLink}/>,

      <Route key="recovery" path="/recovery" exact component={PasswordRecovery}/>,
      <Route key="first-steps" path="/first-steps" exact component={FirstSteps}/>,
      <Route key="redefinePassword" path="/redefinePassword/:key" exact component={RedefinePassword}/>,
      <Route key="sharedStudy" path="/sharedStudy/:uuid" exact component={DownloadStudyPage}/>,
      <Route key="signIn" path="/signIn" exact
             render={(props) => <SignIn {...props} isLoggedIn={!!user.id} originalLocation={this.originalLocation}/>}/>
    ]

    return (
      <StartlibsProvider config={AppPresentation.startlibsConfig}>
        <ThemeProvider theme={AppPresentation.theme}>
          <div className="App" onClick={this.closePopups}>
            <Notifications/>
            <PurviewPageLoader/>
            {
              user.id
              ? <Switch>

                <Route path="/recovery" exact render={() => null}/>
                <Route path="/license" exact render={() => null}/>
                <Route path="/expired" exact render={() => null}/>
                <Route path="/redefinePassword/:key" exact render={() => null}/>
                <Route component={Navbar}/>
              </Switch>
              : <Switch>
                <Route path="/first-steps" component={Navbar}/>
              </Switch>
            }
            <ErrorBoundary Error={PageError}>
              {
                user.id
                ? (
                  <Switch>
                    <Route path="/report/:uid" exact component={Report}/>
                    <Route path="/profile" exact component={ProfileData}/>
                    <Redirect from="/firstSignIn" exact to="/profile"/>
                    <Route path="/workstations" exact component={Workstations}/>
                    <Route path="/account-settings" exact component={AccountSettings}/>
                    <Route path="/deleteAccount/:token" exact to="/signIn" component={ConfirmDeleteAccount}/>
                    <Route path="/reportCleanup/:token" exact
                           render={(props) => <ConfirmDeleteAccount {...props} isReportCleanup/>}/>
                    <Redirect from="/changePassword" exact to="/account-settings"/>
                    <Redirect from="/activated" exact to="/profile?from=activation"/>
                    <Route path="/card-update" exact component={CreditCardUpdate}/>
                    <Route path="/billing" exact component={Billing}/>
                    <Route path="/" exact component={Dashboard}/>
                    {publicRoutes}
                    <Route component={PageNotFound}/>
                  </Switch>
                )
                : hasFetchedUser.isOpen
                  ? <Switch>
                    {publicRoutes}
                    <Redirect from="/billing" exact to="/signIn"/>
                    <Redirect from="/activated" exact to="/signIn"/>
                    <Redirect from="/profile" exact to="/signIn"/>
                    <Redirect from="/account-settings" exact to="/signIn"/>
                    <Redirect from="/changePassword" exact to="/signIn"/>
                    <Redirect from="/deleteAccount/:token" exact to="/signIn"/>
                    <Redirect from="/reportCleanup/:token" exact to="/signIn"/>
                    <Redirect from="/" exact to="/signIn"/>
                    <Route path="/account-deleted" exact component={DeleteAccountFinished}/>
                    <Route component={PageNotFound}/>
                  </Switch>
                  : <Switch>
                    <Route key="sharedStudy" path="/sharedStudy/:uuid" exact component={DownloadStudyPage}/>
                    <Route component={LoadingUser}/>
                  </Switch>
              }
            </ErrorBoundary>
            <ActivationStatusNotification />
            <PlanStatusNotification status={user && user.accountStatus} user={user}
                                    stripeCardAdded={user && user.stripeCardAdded}/>
            <div style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: 100}}>
              <Slot name="Popup"/>
            </div>
            <div style={{position: 'absolute', top: 0, left: 0, right: 0, zIndex: 200}}>
              <Slot name="Portal"/>
              <Slot name="Dialog"/>
              <Slot name="Confirm-Dialog"/>
              <Slot name="Notification"/>
              <Slot name="Notifications"/>
            </div>
          </div>
        </ThemeProvider>
      </StartlibsProvider>
    )
  }
}

@connect(({appUI}) => ({
  notifications: appUI.notifications
}), {clearNotifications})
@withToggles('toggle')
class Notifications extends React.Component {

  componentDidUpdate(oldProps) {
    if (oldProps.notifications !== this.props.notifications && this.props.notifications.length) {
      this.props.toggle.open()
      setTimeout(this.props.toggle.closeAfter(4000, 2000), 100)
    }
    if (!this.props.toggle.isOpen && oldProps.toggle.isOpen) {
      this.props.clearNotifications()
    }
  }

  render() {
    const {toggle, notifications} = this.props
    return toggle.isOpen && (<Fill name="Notifications">
      <div className="system-notification success">
        {notifications}
        <a className="icon icon-x" onClick={toggle.close}/>
      </div>
    </Fill>)
  }
}

@withToggles('dismissed', 'isLoading')
@connect(({user})=>({user}), {setNotifications})
class ActivationStatusNotification extends React.Component {
  element
  state = {}

  componentDidMount() {
    if (this.element) {
      if (this.state.elementHeight !== this.element.offsetHeight)
        this.setState({elementHeight: this.element.offsetHeight})
    }
    this.checkTime()
  }

  checkTime = () => {
    if (new Date(this.props.user.createdDate).getTime() + (60*60*1000) > new Date().getTime()) {
      this.props.dismissed.open()
    }
  }

  sendNewLink = () => {
    this.props.isLoading.open()
    getFetcher("/api/account/activation-link")
      .then(()=> {
        this.props.isLoading.close()
        this.props.setNotifications('Activation email sent, please check your email')
        this.props.dismissed.open()
      })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.createdDate !== this.props.user.createdDate) {
      this.checkTime()
    }
  }

  render() {
    const {dismissed, isLoading, user} = this.props
    if (!user.id || user.activated || dismissed.isOpen) {
      return null
    }
    return <React.Fragment>
      <BottomBannerPlaceholder size={this.state.elementHeight}/>
      <BottomBanner innerRef={(el) => this.element = el} warning>
        <div className="banner-content-container">
          <div className="banner-content">
            <strong>Please activate your account clicking on the link sent to your email.</strong>
            <div className="additional-info">If you do not find the email in your inbox, please check your spam or junk folder.</div>
          </div>
          <Button.a highlight small isLoading={isLoading.isOpen} onClick={this.sendNewLink}>Send a new link</Button.a>
        </div>
        <Icon className="close-icon" icon="x" onClick={dismissed.open}/>
      </BottomBanner>
    </React.Fragment>
  }
}

@withToggles('dismissed', 'isLoadingDownload')
class PlanStatusNotification extends React.Component {

  state = {subscription: null, elementHeight: 0}
  element = null

  componentDidMount() {
    this.load()
  }

  componentDidUpdate(oldProps) {
    if (oldProps.status !== this.props.status) {
      this.load()
    }
    if (this.element) {
      if (this.state.elementHeight !== this.element.offsetHeight)
        this.setState({elementHeight: this.element.offsetHeight})
    } else if (this.state.elementHeight) {
      this.setState({elementHeight: 0})
    }
  }

  load = () => {
    if (this.props.status === 'past_due' || INACTIVE_ACCOUNT_STATUSES.indexOf(this.props.status) >= 0 || (this.props.status === 'trialing' && !this.props.stripeCardAdded)) {
      getFetcher('/api/stripe-customer')
        .then(({daysUntilCancel, customer}) =>
          this.setState({
            daysUntilCancel,
            subscription: normalizeSubscription(customer.subscriptions && customer.subscriptions.data[0])
          })
        )
    } else if (this.props.user.id) {
      getFetcher('/api/account/limits')
        .then((limits) => {
          const [month, dimissedReportCount, dismissedShareCount] = ice.get(this.props.user, ['settings', 'limitsDismissed']) || []
          if (month !== new Date().getMonth() || dimissedReportCount !== limits.currentReports || dismissedShareCount !== limits.currentShares) {
            this.setState({limits: {...limits, dimissedReportCount, dismissedShareCount}})
          }
        })
    }
  }

  closeLimits = () => {
    this.props.dismissed.open()
    postFetcher('/api/settings',
      {
        ...this.props.user.settings,
        limitsDismissed: [new Date().getMonth(), this.state.limits.currentReports, this.state.limits.currentShares]
      },
      {method: 'PUT'}
    )
  }

  trialDaysLeft = () => daysLeft(this.state.subscription.trialEnd * 1000)

  downloadArchive = () => {
    this.props.isLoadingDownload.open()
    downloadReportsArchive()
      .then(() => this.props.isLoadingDownload.close())
      .catch(() => this.props.isLoadingDownload.close())
  }

  renderArchiveBanner = () => this.props.user && this.props.user.id
    ? <BottomBanner innerRef={(el) => this.element = el}>
      <div className="banner-content-container">
        <div className="banner-content">
          <div><strong>Downloading individual reports as PDF is no longer available.</strong></div>
          <div className="additional-info">You can download an archive with all of your reports.</div>
        </div>
        <Button highlight isLoading={this.props.isLoadingDownload.isOpen} onClick={this.downloadArchive}>
          Download report archive
        </Button>
      </div>
      <Icon className="close-icon" icon="x" onClick={this.props.dismissed.open}/>
    </BottomBanner>
    : null

  render() {
    const {dismissed, isLoadingDownload} = this.props
    const {subscription, limits, daysUntilCancel} = this.state
    const paymentScreens = location.pathname.indexOf('/billing') === 0 || location.pathname.indexOf('/firstSignIn') === 0 || location.pathname.indexOf('/checkout') === 0
    return <React.Fragment>
      <BottomBannerPlaceholder size={this.state.elementHeight}/>
      {!subscription || paymentScreens || dismissed.isOpen ?
       <LimitsNotification
         innerRef={(el) => this.element = el}
         closeLimits={this.closeLimits}
         limits={limits}
         dismissed={dismissed}
         fallback={paymentScreens ? null : this.renderArchiveBanner()}
       /> :
       INACTIVE_ACCOUNT_STATUSES.indexOf(subscription.status) >= 0
        ? <BottomBanner innerRef={(el) => this.element = el}>
          <div className="banner-content-container">
            <div className="banner-content">
              <div><strong>Your Horos Cloud reports are now read-only.</strong></div>
              <div className="additional-info">You can no longer create or edit reports. You can still download an
                archive with all of your reports.
              </div>
            </div>
            <Button highlight isLoading={isLoadingDownload.isOpen} onClick={this.downloadArchive}>
              Download report archive
            </Button>
          </div>
          <Icon className="close-icon" icon="x" onClick={dismissed.open}/>
        </BottomBanner>
        : subscription.status === 'past_due'
         ? <BottomBanner innerRef={(el) => this.element = el} warning>
           <div className="banner-content-container">
             <div className="banner-content">
               <div><strong>We’ve identified pending payments in your Horos Cloud
                 subscription.</strong></div>
               <div>Please check your billing details before <FormattedDate
                 date={getCancelDate(subscription.currentPeriodEnd, daysUntilCancel)}
                 format="LL dd"/> to avoid service interruption.
               </div>
             </div>
             <Button.Link highlight to="/billing">Go to billing</Button.Link>
           </div>
           <Icon className="close-icon" icon="x" onClick={dismissed.open}/>
         </BottomBanner>
          : subscription.trialEnd && this.trialDaysLeft() <= 15
            ? <BottomBanner innerRef={(el) => this.element = el}>
              <div className="banner-content-container">
                <div className="banner-content">
                  <strong>
                    {this.trialDaysLeft() === 0 ?
                     ' This is your last free trial day' :
                     ` Your trial period will end in ${this.trialDaysLeft()} days`
                    }
                  </strong>.
                </div>
              </div>
              <Icon className="close-icon" icon="x" onClick={dismissed.open}/>
            </BottomBanner>
            : this.renderArchiveBanner()
      }
    </React.Fragment>
  }
}

const pluralize = (n, suffix = 's', str = '') => n > 1 ? str + suffix : str

const LimitsNotification = ({limits, dismissed, closeLimits, innerRef, fallback = null}) => {
  if (dismissed.isOpen) return null
  if (!limits) return fallback
  let showShareLimits =
    limits.currentShares !== limits.dismissedShareCount &&
    limits.currentPlanShareLimits > 0 &&
    limits.currentShares >= (limits.currentPlanShareLimits * 4 / 5)

  if (!showShareLimits) return fallback

  const remainingShares = limits.currentPlanShareLimits - limits.currentShares

  return <BottomBanner warning innerRef={innerRef}>
    <div className="banner-content-container">
      <div className="banner-content">
        <div>
          <div><strong>
            You have only {remainingShares} more study share{pluralize(remainingShares)} available this month.
          </strong></div>
          <div className="upgrade-cta">Upgrade your plan to have unlimited shares per month.</div>
        </div>
      </div>
      <Button.Link highlight to="/checkout?of=plan">Upgrade your plan</Button.Link>
    </div>
    <Icon className="close-icon" icon="x" onClick={closeLimits}/>
  </BottomBanner>
}

export const App = withRouter(connect(({appUI, user}) => ({
  openPopup: appUI.openPopup,
  user: user
}), {closePopups, getAccount})(withToggles('hasFetchedUser')(AppPresentation)))



// WEBPACK FOOTER //
// ./src/javascripts/App.js